import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserContext } from "../context/UserContext";

const RequireAuth = ({ children }) => {
  const { user, fetchingUser } = useUserContext();
  const location = useLocation();

  if (fetchingUser) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  return children;
};

export default RequireAuth;
